// @ts-nocheck
// @ts-ignore
let mainDesktopInput = document.querySelector('.main-quantity-atc-btn-wrapper input');
let mainDesktopAtcWrapper = document.querySelector('.main-atc-btn');
let mainDesktopAtcBtn = document.querySelector('.custom-atc-btn');
let mainDesktopOptionsWrapper = document.querySelector('.main-variant-options');
let cartComponent = document.querySelector('cart-drawer-component')
let cartArray = window.latestCartData?.items || [];

function getAtcAddLabelHtml(btn) {
    if (isStickyAtcButton(btn)) return '+ Add';
    const bag = (window.AtcPriceBlock && window.AtcPriceBlock.bagHtml) || '';
    return '+ Add' + bag;
}

function getAtcViewCartLabelHtml() {
    return 'View Cart';
}

function isStickyAtcButton(btn) {
    return !!(btn && btn.closest && btn.closest('.sticky-add-to-cart'));
}

function setStickyAtcCtaOnly(btn, isCtaOnly) {
    if (!isStickyAtcButton(btn)) return;
    const footer = btn.closest('.product-details__atc-footer-content');
    if (!footer) return;
    footer.classList.toggle('product-details__atc-footer-content--cta-only', !!isCtaOnly);
}

/** When true, `syncCartDrwer` runs on `cart:section-rendered` instead of immediately (avoids racing cart section morph). */
let pendingSyncCartDrawerAfterSectionRender = false;

/** Call before dispatching `cart:update` when `cart-items-component` will morph (e.g. complementary-products add-to-cart). */
window.requestSyncCartDrawerAfterSectionRender = function requestSyncCartDrawerAfterSectionRender() {
    pendingSyncCartDrawerAfterSectionRender = true;
};

// Cache variant inventory data { variantId: inventoryQuantity }
let variantInventoryCache = {};

// ─── DOM Query Helpers ───────────────────────────────────────────────────────

/** Returns the main (desktop) quantity input */
function getMainQuantityInput() {
    return document.querySelector('.main-quantity-atc-btn-wrapper input[name="quantity"]');
}

/** Returns the sticky bar quantity input */
function getStickyQuantityInput() {
    return document.querySelector('.sticky-add-to-cart__quantity-selector-wrapper input[name="quantity"]');
}

/** Returns all custom-atc-btn elements (main + sticky) */
function getAllAtcButtons() {
    return document.querySelectorAll('.custom-atc-btn');
}

// ─── Inventory Helpers ───────────────────────────────────────────────────────

/**
 * Loads variant inventory from the Liquid-injected window.__variantInventory object.
 * This data comes from Liquid (server-side) so it has accurate inventory_quantity.
 */
function loadInventoryFromLiquid() {
    if (window.__variantInventory && typeof window.__variantInventory === 'object') {
        Object.keys(window.__variantInventory).forEach(id => {
            const v = window.__variantInventory[id];
            variantInventoryCache[parseInt(id, 10)] = {
                quantity: v.quantity,
                policy: v.policy,
                managed: v.managed
            };
        });
    }
}

/**
 * Updates the max attribute and data-cart-quantity on ALL quantity inputs
 * based on the variant's inventory and how many are already in cart.
 */
function enforceMaxQuantity(variantId) {
    const inv = variantInventoryCache[variantId];
    if (!inv || !inv.managed || inv.policy === 'continue') return; // No limit or sells past 0

    const maxAvailable = inv.quantity; // total inventory

    // In our custom flow the quantity selector shows the ABSOLUTE desired cart quantity
    // (not an additive "how many more to add"). So we set data-cart-quantity to 0
    // so that the component's getEffectiveMax() returns max directly (max - 0 = max).
    [getMainQuantityInput(), getStickyQuantityInput()].forEach(input => {
        if (!input) return;
        if (maxAvailable > 0) {
            input.setAttribute('max', maxAvailable);
            input.setAttribute('data-cart-quantity', '0');
        } else {
            // Variant has 0 inventory and policy is deny → effectively sold out
            input.setAttribute('max', '0');
            input.setAttribute('data-cart-quantity', '0');
        }
        // Clamp current value to max if it exceeds
        const currentVal = parseInt(input.value) || 1;
        if (maxAvailable > 0 && currentVal > maxAvailable) {
            input.value = maxAvailable;
        }
    });

    // Also update the quantity-selector-component's button states
    document.querySelectorAll('quantity-selector-component').forEach(comp => {
        if (comp.closest('sticky-add-to-cart') || comp.closest('.main-quantity-atc-btn-wrapper')) {
            if (typeof comp.updateButtonStates === 'function') {
                comp.updateButtonStates();
            }
        }
    });

}

/**
 * Shows a temporary error message below the variant selector.
 * On mobile (< 750px), auto-scrolls the user to the error.
 */
function showCartError(message) {
    const errorStyle = 'color:#EE3224;font-size:13px;margin-top:8px;margin-bottom:0;transition:opacity 0.3s;font-family:inherit;';

    // Show below the variant picker
    const variantPicker = document.querySelector('variant-picker[data-template-product-match="true"]')
        || document.querySelector('variant-picker:not(product-card variant-picker):not(quick-add-dialog variant-picker)');

    let variantErrorEl = null;
    if (variantPicker) {
        variantErrorEl = variantPicker.querySelector('[data-cart-error]');
        if (!variantErrorEl) {
            variantErrorEl = document.createElement('p');
            variantErrorEl.setAttribute('data-cart-error', '');
            variantErrorEl.style.cssText = errorStyle;
            const variantForm = variantPicker.querySelector('form.variant-picker__form') || variantPicker;
            variantForm.appendChild(variantErrorEl);
        }
        variantErrorEl.textContent = message;
        variantErrorEl.style.display = 'block';
        variantErrorEl.style.opacity = '1';
    }

    // On mobile, auto-scroll to the variant error
    if (window.innerWidthCached < 750 && variantErrorEl) {
        variantErrorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    // Auto-hide after 4 seconds
    const hideTimeout = setTimeout(() => {
        if (variantErrorEl && variantErrorEl.parentNode) {
            variantErrorEl.style.opacity = '0';
            setTimeout(() => { variantErrorEl.style.display = 'none'; }, 300);
        }
    }, 4000);

    if (variantErrorEl) {
        clearTimeout(variantErrorEl._timeout);
        variantErrorEl._timeout = hideTimeout;
    }
}

/**
 * Shows "Please select a size" below the variant-picker__form and scrolls to it.
 */
function showVariantSelectionError() {
    // Find the variant picker — use data-template-product-match to target the main product's picker
    const variantPicker = document.querySelector('variant-picker[data-template-product-match="true"]')
        || document.querySelector('variant-picker:not(product-card variant-picker):not(quick-add-dialog variant-picker)');
    if (!variantPicker) return;

    // Scroll to variant picker
    variantPicker.scrollIntoView({ behavior: 'smooth', block: 'center' });

    // Find or create error element below variant-picker__form
    let variantError = variantPicker.querySelector('[data-variant-error]');
    if (!variantError) {
        variantError = document.createElement('p');
        variantError.setAttribute('data-variant-error', '');
        variantError.className = 'variant-picker__error';
        variantError.style.cssText = 'color:#EE3224;font-size:13px;margin-top:8px;margin-bottom:0;transition:opacity 0.3s;';
        const variantForm = variantPicker.querySelector('form.variant-picker__form') || variantPicker;
        variantForm.appendChild(variantError);
    }

    variantError.textContent = 'Please select a size';
    variantError.classList.remove('hidden');
    variantError.style.display = 'block';
    variantError.style.opacity = '1';

    // Auto-hide after 4 seconds
    clearTimeout(variantError._hideTimeout);
    variantError._hideTimeout = setTimeout(() => {
        if (variantError && variantError.parentNode) {
            variantError.style.opacity = '0';
            setTimeout(() => {
                variantError.classList.add('hidden');
                variantError.style.display = 'none';
            }, 300);
        }
    }, 4000);
}

/**
 * Hides the variant selection error message if visible.
 */
function hideVariantSelectionError() {
    const variantError = document.querySelector('[data-variant-error]');
    if (variantError) {
        variantError.classList.add('hidden');
        variantError.style.display = 'none';
        variantError.style.opacity = '0';
    }
}

// ─── Core Logic ──────────────────────────────────────────────────────────────

/**
 * Called when the variant changes on the product page.
 * Checks if the new variant is already in the cart and updates the UI accordingly.
 */
function handleProductVariantChange(changedVariantObject) {
    let productId = changedVariantObject?.productId;
    let selectedVariant = changedVariantObject?.variant;

    // Hide variant selection error if it was showing
    hideVariantSelectionError();

    // If the variant is sold out / unavailable, show "Sold Out" and disable
    if (!selectedVariant.available) {
        updateAllATCButtons('sold out');
        return;
    }

    // Reload inventory data (morph may have updated the Liquid-injected global)
    loadInventoryFromLiquid();

    // Refresh cartArray from latest data
    cartArray = window.latestCartData?.items || [];

    let variantCheck = checkIfVariantPresentInCart(selectedVariant);
    if (!variantCheck.isPresent) {
        updateAllQuantityInputs(variantCheck?.quantityInCart);
        updateAllATCButtons('add to cart');
    } else {
        updateAllQuantityInputs(variantCheck?.quantityInCart);
        updateAllATCButtons('view');
    }

    // Enforce inventory max for the new variant
    if (selectedVariant?.id) {
        enforceMaxQuantity(selectedVariant.id);
    }
}

/**
 * Updates quantity input values on BOTH main and sticky selectors.
 */
function updateAllQuantityInputs(quantity) {
    const mainInput = getMainQuantityInput();
    const stickyInput = getStickyQuantityInput();

    const val = (quantity > 0) ? quantity : 1;

    if (mainInput) mainInput.value = val;
    if (stickyInput) stickyInput.value = val;
}

// Keep the old function name working for backward compat
function updateQuantityInputValue(quantity) {
    updateAllQuantityInputs(quantity);
}

/**
 * Called when any quantity selector value changes.
 * Determines if the variant is in cart and whether the quantity differs,
 * then sets all button states accordingly.
 * @param {number} [newQty] - The new quantity from the event detail (optional fallback).
 * @param {HTMLElement} [sourceEl] - The element that dispatched the event (to identify main vs sticky).
 */
function handleQuantityUpdate(newQty, sourceEl) {
    const selectedVariantId = getSelectedVariantId();
    if (!selectedVariantId) return;

    // Refresh cartArray
    cartArray = window.latestCartData?.items || [];

    const variantCheckInCart = checkIfVariantPresentInCart({ id: selectedVariantId });

    // Figure out the current quantity from the right input
    let currentInputQty = newQty;
    if (!currentInputQty) {
        // Determine which input to read based on source
        const isFromSticky = sourceEl && sourceEl.closest('sticky-add-to-cart');
        const input = isFromSticky ? getStickyQuantityInput() : getMainQuantityInput();
        currentInputQty = parseInt(input?.value) || 1;
    }

    // Clamp quantity to inventory max (if tracked and policy is deny)
    const inv = variantInventoryCache[parseInt(selectedVariantId, 10)];
    if (inv && inv.managed && inv.policy === 'deny' && inv.quantity > 0) {
        if (currentInputQty > inv.quantity) {
            currentInputQty = inv.quantity;
            showCartError(`Only ${inv.quantity} available for this variant.`);
        }
    }

    // Sync both inputs to the same value
    const mainInput = getMainQuantityInput();
    const stickyInput = getStickyQuantityInput();
    if (mainInput) mainInput.value = currentInputQty;
    if (stickyInput) stickyInput.value = currentInputQty;

    if (variantCheckInCart.isPresent) {
        if (currentInputQty !== variantCheckInCart.quantityInCart) {
            updateAllATCButtons('update');
        } else {
            updateAllATCButtons('view');
        }
    } else {
        updateAllATCButtons('add to cart');
    }
}

/**
 * Disables or enables ALL quantity selectors (main + sticky).
 * When disabled, the +/- buttons and input are disabled and the wrapper is visually dimmed.
 */
function setQuantitySelectorsDisabled(disabled) {
    // Target only the quantity-selector-component (or .quantity-selector) elements
    // inside the main and sticky wrappers — NOT the whole wrapper which also holds the ATC button.
    const selectors = [
        '.main-quantity-atc-btn-wrapper quantity-selector-component',
        '.main-quantity-atc-btn-wrapper .quantity-selector',
        '.sticky-add-to-cart__quantity-selector-wrapper quantity-selector-component',
        '.sticky-add-to-cart__quantity-selector-wrapper .quantity-selector'
    ];

    document.querySelectorAll(selectors.join(', ')).forEach(qtyEl => {
        const input = qtyEl.querySelector('input[name="quantity"]');
        const minusBtn = qtyEl.querySelector('.quantity-minus, [ref="minusButton"]');
        const plusBtn = qtyEl.querySelector('.quantity-plus, [ref="plusButton"]');

        if (input) input.disabled = disabled;
        if (minusBtn) minusBtn.disabled = disabled;
        if (plusBtn) plusBtn.disabled = disabled;

        qtyEl.style.opacity = disabled ? '0.4' : '';
        qtyEl.style.pointerEvents = disabled ? 'none' : '';
    });
}

/**
 * Updates ALL ATC button texts and data-currentAction (main + sticky).
 */
function updateAllATCButtons(state) {
    const buttons = getAllAtcButtons();
    buttons.forEach(btn => {
        const footerContent = btn.closest('.product-details__atc-footer-content');
        const footer = btn.closest('.product-details__atc-footer');

        if (state === 'sold out') {
            setStickyAtcCtaOnly(btn, false);
            btn.innerText = 'Sold Out';
            btn.dataset.currentAction = 'sold out';
            btn.style.pointerEvents = 'none';
            btn.style.color = '#999999';
            if (footerContent) footerContent.style.pointerEvents = 'none';
            // Keep price and separator visible for sold out state
            if (footerContent) {
                const price = footerContent.querySelector('.product-details__atc-price');
                const separator = footerContent.querySelector('.product-details__atc-separator');
                if (price) price.style.display = '';
                if (separator) separator.style.display = '';
            }
        } else {
            // Re-enable the button and footer for non-sold-out states
            btn.style.pointerEvents = '';
            btn.style.color = '';
            if (footerContent) footerContent.style.pointerEvents = '';
            // Restore price and separator visibility
            if (footerContent) {
                const price = footerContent.querySelector('.product-details__atc-price');
                const separator = footerContent.querySelector('.product-details__atc-separator');
                if (price) price.style.display = '';
                if (separator) separator.style.display = '';
            }

            if (state === 'view') {
                if (isStickyAtcButton(btn)) {
                    setStickyAtcCtaOnly(btn, true);
                    btn.innerHTML = getAtcViewCartLabelHtml();
                } else {
                    setStickyAtcCtaOnly(btn, false);
                    btn.innerText = 'View Cart';
                }
                btn.dataset.currentAction = 'open cart';
            } else if (state === 'add to cart') {
                setStickyAtcCtaOnly(btn, false);
                btn.innerHTML = getAtcAddLabelHtml(btn);
                btn.dataset.currentAction = 'add to cart';
            } else if (state === 'update') {
                setStickyAtcCtaOnly(btn, false);
                btn.innerText = 'Update';
                btn.dataset.currentAction = 'update';
            }
        }
    });

    // Disable quantity selectors when sold out, re-enable otherwise
    setQuantitySelectorsDisabled(state === 'sold out');
}

// Keep the old function name working
function updateATCButtonState(state) {
    updateAllATCButtons(state);
}

/**
 * Checks if a given variant (by id) exists in the cart.
 * Returns { isPresent, quantityInCart }.
 */
function checkIfVariantPresentInCart(variant) {
    const variantId = variant.id;

    const cartItem = cartArray.find(
        item => item.variant_id === variantId || parseInt(item.variant_id, 10) === parseInt(variantId, 10)
    );

    return {
        isPresent: Boolean(cartItem),
        quantityInCart: cartItem ? cartItem.quantity : 0,
        cartItem: cartItem || null
    };
}

/**
 * Dispatches a 'cart:update' event so the cart drawer (cart-items-component) re-renders.
 */
function dispatchCartUpdateEvent(cartData) {
    document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
            resource: cartData || window.latestCartData,
            sourceId: 'custom-product-atc',
            data: {
                source: 'custom-product-atc',
                itemCount: (cartData || window.latestCartData)?.item_count || 0
            }
        }
    }));
}

/**
 * Gets the currently selected variant ID from multiple sources.
 */
function getSelectedVariantId() {
    // 1. Try the hidden input first (populated by variant-picker JS)
    const variantIdInput = document.querySelector('input[name="id"][ref="variantId"]');
    if (variantIdInput && variantIdInput.value) {
        return parseInt(variantIdInput.value, 10);
    }

    // 2. Try the URL ?variant= parameter (available immediately on page load)
    const urlParams = new URLSearchParams(window.location.search);
    const urlVariant = urlParams.get('variant');
    if (urlVariant) {
        return parseInt(urlVariant, 10);
    }

    // 3. Fallback: check variant option inputs (checked or data-current-checked)
    mainDesktopOptionsWrapper = document.querySelector('.main-variant-options');
    const allVariants = mainDesktopOptionsWrapper?.querySelectorAll('input') || [];
    const selectedVariant = [...allVariants].find(
        v => v.checked || v.dataset.currentChecked === 'true'
    );
    if (selectedVariant && selectedVariant.dataset.variantId) {
        return Number(selectedVariant.dataset.variantId);
    }

    return null;
}

/**
 * Reads the quantity from the correct input based on which button was clicked.
 * @param {HTMLElement} clickedBtn - The .custom-atc-btn that was clicked.
 */
function getQuantityForButton(clickedBtn) {
    const isSticky = clickedBtn.closest('sticky-add-to-cart');
    const input = isSticky ? getStickyQuantityInput() : getMainQuantityInput();
    return parseInt(input?.value) || 1;
}

// ─── Click Handler (works for BOTH main and sticky) ──────────────────────────

/**
 * Handles the click on ANY custom ATC button area (main or sticky).
 * Depending on the current state: adds to cart, opens cart, or updates cart quantity.
 */
async function handleCustomButtonClick(ele) {
    let actualBtn = ele?.querySelector('.custom-atc-btn');
    if (!actualBtn) return;

    // Re-query cart component
    cartComponent = document.querySelector('cart-drawer-component');

    let actionToPerform = actualBtn.dataset.currentAction;
    if (actionToPerform === 'sold out') {
        // Do nothing when sold out
        return;
    }
    if (actionToPerform === 'open cart') {
        // Open the cart drawer
        if (cartComponent) {
            cartComponent.open();
        }
    } else if (actionToPerform === 'add to cart') {
        enableNudges('add to cart')
        // Add variant to cart
        // let toolTip = document.querySelector('.main-quantity-atc-btn-wrapper .qty-tooltip');
        // let ATCNotification = document.querySelector('.product-addedNotification');
        // ATCNotification.querySelector('.notification-tag').innerText = 'The product is added in your bag.';
        // toolTip.style.display = 'block';
        // ATCNotification.style.display = 'flex';
        const variantId = getSelectedVariantId();
        if (!variantId) {
            showVariantSelectionError();
            return;
        }
        let quantity = getQuantityForButton(actualBtn);

        // Clamp to inventory if tracked
        const invAdd = variantInventoryCache[parseInt(variantId, 10)];
        if (invAdd && invAdd.managed && invAdd.policy === 'deny' && invAdd.quantity > 0 && quantity > invAdd.quantity) {
            quantity = invAdd.quantity;
            showCartError(`Only ${invAdd.quantity} available. Quantity adjusted.`);
            updateAllQuantityInputs(quantity);
        }
        let deferCgwwSync = false;
        try {
            // Check if there are available upsell products BEFORE adding to cart
            const _upsellProducts = window.__upsellingPdpProducts || [];
            const _hasAvailableUpsells = _upsellProducts.some(p => p.available);

            // Temporarily suppress cart drawer auto-open if upsell popup will show
            if (_hasAvailableUpsells && cartComponent) {
                cartComponent.removeAttribute('auto-open');
            }

            // Update ALL buttons to show loading
            getAllAtcButtons().forEach(btn => {
                setStickyAtcCtaOnly(btn, true);
                btn.innerText = 'Adding...';
                btn.style.pointerEvents = 'none';
            });

            await addVariantToCart(variantId, quantity);


            // Re-fetch full cart so latestCartData is accurate
            const freshCart = await fetch('/cart.js').then(r => r.json());
            window.latestCartData = freshCart;

            // Refresh cartArray after adding
            cartArray = window.latestCartData?.items || [];

            // Defer "choice goes well with" sync until cart-items section has morphed (avoids skeleton stuck state)
            deferCgwwSync = !!document.querySelector('cart-items-component');
            if (deferCgwwSync) {
                pendingSyncCartDrawerAfterSectionRender = true;
            }

            // Dispatch cart:update so the cart drawer re-renders
            dispatchCartUpdateEvent(freshCart);

            // Update ALL buttons to "View Cart"
            updateAllATCButtons('view');

            // Update ALL quantity inputs to reflect what's in cart
            const variantCheck = checkIfVariantPresentInCart({ id: variantId });
            updateAllQuantityInputs(variantCheck.quantityInCart);

            // Enforce max quantity based on inventory
            enforceMaxQuantity(variantId);

            // Open cart drawer only if no available upsell products (popup will show instead)
            if (cartComponent && !_hasAvailableUpsells) {
                // Restore auto-open before opening (in case it was removed somehow)
                cartComponent.setAttribute('auto-open', '');
                cartComponent.open();
            }

            // Show upsell popup after ATC
            showUpsellPopupAfterATC();


        } catch (error) {
            console.error('Failed to add to cart:', error);
            showCartError(error.message || 'Could not add to cart. Please try again.');
            // Restore auto-open on error so cart drawer works normally again
            if (cartComponent && !cartComponent.hasAttribute('auto-open')) {
                cartComponent.setAttribute('auto-open', '');
            }
            // Reset to proper state: re-fetch cart, check if variant is already in cart
            const freshCart = await fetch('/cart.js').then(r => r.json()).catch(() => null);
            if (freshCart) {
                window.latestCartData = freshCart;
                cartArray = freshCart.items || [];
            }
            const variantCheck = checkIfVariantPresentInCart({ id: variantId });
            if (variantCheck.isPresent) {
                updateAllATCButtons('view');
                updateAllQuantityInputs(variantCheck.quantityInCart);
            } else {
                updateAllATCButtons('add to cart');
                updateAllQuantityInputs(1);
            }
            enforceMaxQuantity(variantId);
        } finally {
            disableNudges();
            if (!deferCgwwSync) {
                syncCartDrwer();
            }
            getAllAtcButtons().forEach(btn => {
                btn.style.pointerEvents = '';
            });
        }
    } else if (actionToPerform === 'update') {
        // let toolTip = document.querySelector('.main-quantity-atc-btn-wrapper .qty-tooltip');
        // let ATCNotification = document.querySelector('.product-addedNotification');
        // ATCNotification.querySelector('.notification-tag').innerText = 'The product is updated in your bag.';
        // toolTip.style.display = 'block';
        // ATCNotification.style.display = 'flex';
        enableNudges('update')
        // Update the quantity in cart (SET to the new quantity, not add)
        const variantId = getSelectedVariantId();
        if (!variantId) {
            showVariantSelectionError();
            return;
        }
        let newQuantity = getQuantityForButton(actualBtn);

        // Clamp to inventory if tracked
        const invUpd = variantInventoryCache[parseInt(variantId, 10)];
        if (invUpd && invUpd.managed && invUpd.policy === 'deny' && invUpd.quantity > 0 && newQuantity > invUpd.quantity) {
            newQuantity = invUpd.quantity;
            showCartError(`Only ${invUpd.quantity} available. Quantity adjusted.`);
            updateAllQuantityInputs(newQuantity);
        }

        let deferCgwwSyncUpd = false;
        try {
            // Check if there are available upsell products BEFORE updating cart
            const _upsellProductsUpd = window.__upsellingPdpProducts || [];
            const _hasAvailableUpsellsUpd = _upsellProductsUpd.some(p => p.available);

            // Temporarily suppress cart drawer auto-open if upsell popup will show
            if (_hasAvailableUpsellsUpd && cartComponent) {
                cartComponent.removeAttribute('auto-open');
            }

            // Update ALL buttons to show loading
            getAllAtcButtons().forEach(btn => {
                setStickyAtcCtaOnly(btn, true);
                btn.innerText = 'Updating...';
                btn.style.pointerEvents = 'none';
            });

            await updateVariantInCart(variantId, newQuantity);

            disableNudges();

            // Refresh cartArray after updating
            cartArray = window.latestCartData?.items || [];

            deferCgwwSyncUpd = !!document.querySelector('cart-items-component');
            if (deferCgwwSyncUpd) {
                pendingSyncCartDrawerAfterSectionRender = true;
            }

            // Dispatch cart:update so the cart drawer re-renders
            dispatchCartUpdateEvent(window.latestCartData);

            // Update ALL buttons to "View Cart"
            updateAllATCButtons('view');

            // Sync quantity inputs to actual cart quantity
            const variantCheck = checkIfVariantPresentInCart({ id: variantId });
            updateAllQuantityInputs(variantCheck.quantityInCart);

            // Enforce max quantity
            enforceMaxQuantity(variantId);

            // Open cart drawer only if no available upsell products (popup will show instead)
            if (cartComponent && !_hasAvailableUpsellsUpd) {
                // Restore auto-open before opening
                cartComponent.setAttribute('auto-open', '');
                cartComponent.open();
            }

            // Show upsell popup after update
            showUpsellPopupAfterATC();


        } catch (error) {
            console.error('Failed to update cart:', error);
            showCartError(error.message || 'Could not update cart. Quantity may exceed available stock.');
            // Restore auto-open on error so cart drawer works normally again
            if (cartComponent && !cartComponent.hasAttribute('auto-open')) {
                cartComponent.setAttribute('auto-open', '');
            }
            // Reset to actual cart state
            const freshCart = await fetch('/cart.js').then(r => r.json()).catch(() => null);
            if (freshCart) {
                window.latestCartData = freshCart;
                cartArray = freshCart.items || [];
            }
            const variantCheck = checkIfVariantPresentInCart({ id: variantId });
            if (variantCheck.isPresent) {
                updateAllATCButtons('view');
                updateAllQuantityInputs(variantCheck.quantityInCart);
            } else {
                updateAllATCButtons('add to cart');
                updateAllQuantityInputs(1);
            }
            enforceMaxQuantity(variantId);
        } finally {
            disableNudges();
            if (!deferCgwwSyncUpd) {
                syncCartDrwer();
            }
            getAllAtcButtons().forEach(btn => {
                btn.style.pointerEvents = '';
            });
        }
    }
}

function enableNudges(state) {
    let toolTip = document.querySelector('.main-quantity-atc-btn-wrapper .qty-tooltip');
    let ATCNotification = document.querySelector('.product-addedNotification');
    if(state == 'update') {
        if(ATCNotification.querySelector('.notification-tag')){
            ATCNotification.querySelector('.notification-tag').innerText = 'The product is updated in your bag.';
        }
        // toolTip.style.display = 'block';
        if(ATCNotification){
            ATCNotification.style.display = 'flex';
        }
    } else if (state == 'add to cart') {
        if( ATCNotification.querySelector('.notification-tag')){
            ATCNotification.querySelector('.notification-tag').innerText = 'The product is added in your bag.';
        }
        if(toolTip){
            toolTip.style.display = 'block';
        }
        if(ATCNotification){
        ATCNotification.style.display = 'flex';
        }

    }

    // setTimeout(() => {
    //     disableNudges()
    // }, 1000)
}

function disableNudges() {
    let toolTip = document.querySelector('.main-quantity-atc-btn-wrapper .qty-tooltip');
    let ATCNotification = document.querySelector('.product-addedNotification');
    if(toolTip){
        toolTip.style.display = 'none'
    }
    if(ATCNotification){
    ATCNotification.style.display = 'none'

    }
}

// ─── Cart Helper Functions ───────────────────────────────────────────────────

/**
 * Adds a variant to the cart with the given quantity.
 */
async function addVariantToCart(variantId, quantity) {
    try {
        let numericVariantId = String(variantId);
        if (String(variantId).includes('gid://')) {
            const match = String(variantId).match(/\/(\d+)$/);
            if (match && match[1]) {
                numericVariantId = match[1];
            }
        }

        const formData = {
            items: [{
                id: parseInt(numericVariantId, 10),
                quantity: Number(quantity)
            }]
        };

        const shopifyRoutes = typeof window !== 'undefined' && window.Shopify && window.Shopify.routes;
        const root = (shopifyRoutes && shopifyRoutes.root) || '/';

        const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
        });

        const responseText = await response.text();
        let parsedResponse;
        try {
            parsedResponse = JSON.parse(responseText);
        } catch (e) {
            parsedResponse = { raw: responseText };
        }

        if (!response.ok) {
            console.error('🛒 Cart add error response:', parsedResponse);
            throw new Error(parsedResponse.message || parsedResponse.description || response.statusText);
        }

        // Run auditzyTrackingScript if fetch is successful
        try {
            if (typeof window !== 'undefined' && typeof window.auditzyTrackingScript === 'function') {
                window.auditzyTrackingScript();
            } else if (typeof auditzyTrackingScript === 'function') {
                auditzyTrackingScript();
            }
        } catch (err) {
            console.warn('auditzyTrackingScript failed:', err);
        }

        // Update latestCartData
        if (window.latestCartData && Array.isArray(window.latestCartData.items)) {
            window.latestCartData.items.unshift(...parsedResponse.items);
        } else {
            // Re-fetch full cart to get accurate data
            const cartResp = await fetch('/cart.js');
            if (cartResp.ok) {
                window.latestCartData = await cartResp.json();
            }
        }

        return parsedResponse;
    } catch (error) {
        console.error('Error adding variant to cart:', error);
        throw error;
    }
}

/**
 * Updates a variant's quantity in the cart to the exact newQuantity (replaces, does not add).
 * Uses /cart/update.js with the line item key.
 */
async function updateVariantInCart(variantId, newQuantity) {
    try {
        const numericVariantId = parseInt(String(variantId).includes('gid://')
            ? (String(variantId).match(/\/(\d+)$/)?.[1] || variantId)
            : variantId, 10);

        // Ensure we have cart data
        if (!window.latestCartData || !Array.isArray(window.latestCartData.items)) {
            const cartResponse = await fetch('/cart.js');
            if (!cartResponse.ok) {
                throw new Error(`Failed to fetch cart: ${cartResponse.status}`);
            }
            window.latestCartData = await cartResponse.json();
        }

        // Find the existing item in cart
        const existingItem = window.latestCartData.items.find(
            item => parseInt(item.variant_id, 10) === numericVariantId
        );

        if (!existingItem) {
            throw new Error('Variant not found in cart, cannot update');
        }

        // Use the line item key to SET the quantity (not add to it)
        const lineKey = existingItem.key;
        const updates = { [lineKey]: newQuantity };

        const root = (window.Shopify?.routes?.root) || '/';

        const response = await fetch(`${root}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
        });

        const responseText = await response.text();
        let result;
        try {
            result = JSON.parse(responseText);
        } catch (e) {
            result = { raw: responseText };
        }

        if (!response.ok) {
            console.error('🛒 Cart update error response:', result);
            throw new Error(result.message || result.description || `Cart update failed: ${response.status}`);
        }

        window.latestCartData = result;

        return result;
    } catch (error) {
        console.error('Error updating variant in cart:', error);
        throw error;
    }
}



document.addEventListener('cart:section-rendered', () => {
    if (!pendingSyncCartDrawerAfterSectionRender) return;
    pendingSyncCartDrawerAfterSectionRender = false;
    syncCartDrwer();
    requestAnimationFrame(() => {
        // Reload SmartWishlist after cart drawer re-render
        if (typeof resetModalTrendingList === 'function') {
            resetModalTrendingList();
        }
        // Reload SmartWishlist after cart drawer re-render
        if (typeof renderRecentSearches === 'function') {
            renderRecentSearches();
        }
    })
});

// ─── Initialization ──────────────────────────────────────────────────────────

let _initDone = false;

/**
 * On page load, check if the currently selected variant is already in the cart
 * and set the button state accordingly (View Cart / Add to Bag) for BOTH main and sticky.
 */
async function initButtonState() {
    // Ensure latestCartData is available; fetch if not
    if (!window.latestCartData || !Array.isArray(window.latestCartData.items)) {
        try {
            const cartResp = await fetch('/cart.js');
            if (cartResp.ok) {
                window.latestCartData = await cartResp.json();
            }
        } catch (e) {
            console.error('Failed to fetch cart on init:', e);
        }
    }

    cartArray = window.latestCartData?.items || [];

    // Re-query DOM elements
    cartComponent = document.querySelector('cart-drawer-component');

    const selectedVariantId = getSelectedVariantId();
    if (!selectedVariantId) {
        // Variant ID not available yet — retry after a short delay (variant-picker JS may not have run yet)
        if (!_initDone) {
            setTimeout(initButtonState, 500);
        }
        return;
    }

    _initDone = true;

    // Load inventory data from Liquid-injected global
    loadInventoryFromLiquid();

    // Check if the variant is sold out (inventory 0, managed, policy deny)
    const inv = variantInventoryCache[selectedVariantId];
    if (inv && inv.managed && inv.policy === 'deny' && inv.quantity <= 0) {
        updateAllATCButtons('sold out');
        return;
    }

    const variantCheck = checkIfVariantPresentInCart({ id: selectedVariantId });

    if (variantCheck.isPresent) {
        updateAllQuantityInputs(variantCheck.quantityInCart);
        updateAllATCButtons('view');
    } else {
        updateAllQuantityInputs(0);
        updateAllATCButtons('add to cart');
    }

    // Enforce max on quantity inputs based on inventory
    enforceMaxQuantity(selectedVariantId);
}

// Run init once the DOM is fully loaded
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initButtonState);
} else {
    // DOM already ready (script loaded with defer)
    initButtonState();
}

// Also run init when the variant picker fires its first variant:update event
document.addEventListener('variant:update', function onFirstVariantUpdate() {
    if (!_initDone) {
        initButtonState();
    }
    document.removeEventListener('variant:update', onFirstVariantUpdate);
});

// ─── Event Listeners ─────────────────────────────────────────────────────────

// Listen for quantity selector changes from BOTH main and sticky (the theme dispatches 'quantity-selector:update')
document.addEventListener('quantity-selector:update', function (e) {
    // Ignore cart drawer quantity changes (they have a cartLine)
    if (e?.detail?.cartLine) return;

    const newQty = e?.detail?.quantity;
    const sourceEl = e?.target instanceof Node ? e.target : null;
    handleQuantityUpdate(newQty, sourceEl);
});

// Listen for manual input changes on quantity fields (event delegation for both main + sticky)
document.addEventListener('change', function (e) {
    if (e.target && (
        e.target.matches('.main-quantity-atc-btn-wrapper input[name="quantity"]') ||
        e.target.matches('.sticky-add-to-cart__quantity-selector-wrapper input[name="quantity"]')
    )) {
        handleQuantityUpdate(parseInt(e.target.value) || 1, e.target);
    }
});

// ─── Sync button state when cart changes externally (cart drawer remove/update) ────

/**
 * Refreshes button/quantity state using the cart data from the event
 * or by fetching /cart.js as a fallback.
 */
function refreshButtonStateFromCart(cartData) {
    // Use provided cart data or fetch fresh
    if (cartData && Array.isArray(cartData.items)) {
        window.latestCartData = cartData;
        cartArray = cartData.items;
    }

    const selectedVariantId = getSelectedVariantId();
    if (!selectedVariantId) return;

    // Check if the variant is sold out (inventory 0, managed, policy deny)
    const inv = variantInventoryCache[selectedVariantId];
    if (inv && inv.managed && inv.policy === 'deny' && inv.quantity <= 0) {
        updateAllATCButtons('sold out');
        return;
    }

    const variantCheck = checkIfVariantPresentInCart({ id: selectedVariantId });

    if (variantCheck.isPresent) {
        updateAllQuantityInputs(variantCheck.quantityInCart);
        updateAllATCButtons('view');
    } else {
        updateAllQuantityInputs(1);
        updateAllATCButtons('add to cart');
    }

    enforceMaxQuantity(selectedVariantId);
}

// Theme's cart-items-component dispatches 'cart:update' (a CartUpdateEvent) after quantity change or removal
document.addEventListener('cart:update', function (e) {
    // Ignore events we dispatched ourselves to avoid loops
    if (e?.detail?.data?.source === 'custom-product-atc') return;

    // Use the cart data from the event (detail.resource is the full cart JSON)
    const cartData = e?.detail?.resource;
    if (cartData) {
        refreshButtonStateFromCart(cartData);
    } else {
        fetch('/cart.js').then(r => r.json()).then(freshCart => {
            refreshButtonStateFromCart(freshCart);
        }).catch(err => console.warn('custom-product-atc: failed to refresh cart', err));
    }
});

// custom-cart-controllers dispatches 'cart:updated' (with trailing 'd') after its own updates
document.addEventListener('cart:updated', function (e) {
    const cartData = e?.detail;
    if (cartData && Array.isArray(cartData.items)) {
        refreshButtonStateFromCart(cartData);
    } else {
        fetch('/cart.js').then(r => r.json()).then(freshCart => {
            refreshButtonStateFromCart(freshCart);
        }).catch(err => console.warn('custom-product-atc: failed to refresh cart', err));
    }
});

// ─── Direct handlers for quantity +/- buttons (main desktop + sticky bar) ─────
// The theme's Component on:click bindings break after morph, so we use event delegation.
document.addEventListener('click', function (e) {
    const btn = e.target.closest('.sticky-add-to-cart__quantity-selector-wrapper button')
             || e.target.closest('.main-quantity-atc-btn-wrapper button');
    if (!btn) return;

    const isSticky = !!btn.closest('.sticky-add-to-cart__quantity-selector-wrapper');

    // For the main (non-sticky) quantity selector the component's own handler works
    // correctly and calls preventDefault(). Skip to avoid double-increment.
    if (e.defaultPrevented && !isSticky) return;

    const wrapper = btn.closest('.sticky-add-to-cart__quantity-selector-wrapper')
                 || btn.closest('.main-quantity-atc-btn-wrapper');
    if (!wrapper) return;

    const input = wrapper.querySelector('input[name="quantity"]');
    if (!input) return;

    // For the sticky bar: after morph the component's refs become stale (point to
    // detached elements), so its on:click handler updates a ghost input while calling
    // preventDefault(). In that case we must still run this delegated handler.
    // BUT when NO morph has happened (e.g. no variant selected yet) the component's
    // refs are still fresh and it already updated the REAL input — running this
    // handler too would double-increment (1→3→5→7). Detect that by comparing the
    // component's ref to the real input: if they match, just sync without incrementing.
    if (isSticky && e.defaultPrevented) {
        const component = btn.closest('quantity-selector-component');
        if (component && component.refs && component.refs.quantityInput === input) {
            // Component handler already incremented the real input — just sync & dispatch.
            const currentVal = parseInt(input.value) || 1;

            // Check if user tried to increment but hit inventory max
            if (btn.matches('[name="plus"], [ref="plusButton"], .quantity-plus')) {
                const selectedVariantId = getSelectedVariantId();
                if (selectedVariantId) {
                    const inv = variantInventoryCache[parseInt(selectedVariantId, 10)];
                    if (inv && inv.managed && inv.policy === 'deny' && inv.quantity > 0 && currentVal >= inv.quantity) {
                        showCartError('Maximum available quantity reached.');
                    }
                }
            }

            handleQuantityUpdate(currentVal, input);
            document.dispatchEvent(new CustomEvent('quantity-selector:update', {
                bubbles: true,
                detail: { quantity: currentVal }
            }));
            return;
        }
    }

    const min = parseInt(input.min) || 1;
    let max = input.max ? parseInt(input.max) : Infinity;
    const step = parseInt(input.step) || 1;
    let currentVal = parseInt(input.value) || min;

    // Also check inventory cache for max
    const selectedVariantId = getSelectedVariantId();
    if (selectedVariantId && variantInventoryCache[selectedVariantId]) {
        const inv = variantInventoryCache[selectedVariantId];
        if (inv.managed && inv.policy === 'deny' && inv.quantity > 0) {
            max = Math.min(max, inv.quantity);
        }
    }

    if (btn.matches('[name="plus"], [ref="plusButton"], .quantity-plus')) {
        if (currentVal >= max) {
            showCartError('Maximum available quantity reached.');
            return;
        }
        currentVal = Math.min(max, currentVal + step);
    } else if (btn.matches('[name="minus"], [ref="minusButton"], .quantity-minus')) {
        currentVal = Math.max(min, currentVal - step);
    } else {
        return; // Not a +/- button
    }

    input.value = currentVal;

    // Sync main input and update button states
    handleQuantityUpdate(currentVal, input);

    // Dispatch quantity-selector:update so the StickyATCPrice class updates the price
    document.dispatchEvent(new CustomEvent('quantity-selector:update', {
        bubbles: true,
        detail: { quantity: currentVal }
    }));
});

// ─── Show error when clicking disabled + button on main desktop or sticky quantity selector ───
// The theme disables the + button when value = max, but click events don't fire on
// disabled buttons. pointerdown fires regardless, so we use it to detect the tap.
document.addEventListener('pointerdown', function (e) {
    const plusBtn = e.target.closest('.main-quantity-atc-btn-wrapper .quantity-plus')
                 || e.target.closest('.sticky-add-to-cart__quantity-selector-wrapper .quantity-plus');
    if (plusBtn && plusBtn.disabled) {
        showCartError('Maximum available quantity reached.');
    }
});

window.globalDisableNudges = disableNudges;
window.globalEnableNudges = enableNudges;

